import { Component, input, output } from '@angular/core';
import { CheckBoxDirective } from '@progress/kendo-angular-inputs';
import { TooltipDirective } from '@progress/kendo-angular-tooltip';
import { NotificationWorkItemWrapper } from '../../model/notification-work-item-wrapper';

@Component({
  selector: 'app-notifications-list-item-work-item',
  templateUrl: './notifications-list-item-work-item.component.html',
  styleUrl: './notifications-list-item-work-item.component.scss',
  imports: [TooltipDirective, CheckBoxDirective]
})
export class NotificationsListItemWorkItemComponent {
  public readonly notification = input.required<NotificationWorkItemWrapper>();

  readonly selectionChanged = output<boolean>();
  readonly itemClick = output<void>();
  readonly navigateClick = output<void>();
  readonly deleteClick = output<boolean>();

  isHovering: boolean;

  onHover(): void {
    this.isHovering = true;
  }

  onLeave(): void {
    this.isHovering = false;
  }

  onClick(event: PointerEvent): void {
    const targetElement = event.target as HTMLElement;
    if (targetElement.classList.contains('action-control')) {
      // don't take any action, the specific handlers will take care of the event
    } else {
      this.itemClick.emit();
    }
  }

  onSelectionChanged(): void {
    this.notification().selected = !this.notification().selected;
    this.selectionChanged.emit(this.notification().selected);
  }

  onDelete(): void {
    this.notification().deleted = true;
    this.deleteClick.emit(this.notification().deleted);
  }

  // need this only for some tests -> remove it later
  actionsClick(event: PointerEvent): void {
    const clickedElement = event.target as HTMLElement;
    if (clickedElement.classList.contains('actions')) {
      event.preventDefault();
    }
  }

  navigate(): void {
    this.navigateClick.emit();
  }
}
